import { render, staticRenderFns } from "./IntroThirdPage.vue?vue&type=template&id=a012d140&scoped=true&"
import script from "./IntroThirdPage.vue?vue&type=script&lang=js&"
export * from "./IntroThirdPage.vue?vue&type=script&lang=js&"
import style0 from "./IntroThirdPage.vue?vue&type=style&index=0&id=a012d140&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a012d140",
  null
  
)

export default component.exports